const setContentMessageStatus = ({commit}, args) => {
  commit('CONTENT_MESSAGE_STATUS', args);
};

export default {
  setContentMessageStatus
}
